<template>
    <button class="btn" :class="buttonClasses" @click="onButtonClick" :style="buttonStyles">
        {{component.value}}
    </button>
</template>

<script>
    export default {
        name: 'ButtonRenderer',
        props: ['component', 'executeClick', 'layout'],
        computed: {
            buttonClasses() {
                return `${this.colorClass} ${this.backgroundColorClass} ${this.buttonSizeClass} ${this.sizeClasses} ${this.marginClasses} ${this.paddingClasses}`.trim()
            },
            buttonStyles() {
                return `${this.colorStyle} ${this.backgroundColorStyle} ${this.borderRadiusStyle} ${this.minWidthStyle}`
            },
            marginClasses() {
                if(!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },
            paddingClasses() {
                if(!this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },
            sizeClasses() {
                if(!this.component.style.size) {
                    return ''
                }

                return `${this.component.style.size}`
            },
            buttonSizeClass() {
                if(this.component.style.buttonSize === 'small') {
                    return 'btn-sm'
                }
                else if(this.component.style.buttonSize === 'large') {
                    return 'btn-lg'
                }

                return ''
            },
            colorClass() {
                if(this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0 ) {

                    if(this.layout.theme_id && this.component.style.color === 'primary') {
                        return `btn-primary-theme`
                    }
                    else if(this.layout.theme_id && this.component.style.color === 'secondary') {
                        return `btn-secondary-theme`
                    }

                    return `btn-${this.component.style.color}`
                }

                return ''
            },
            backgroundColorClass() {
                if(this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0 ) {
                    return ''
                }

                if(this.component.style && this.component.style.backgroundColor && this.component.style.backgroundColor !== 'custom' && this.component.style.backgroundColor.indexOf('#') !== 0 ) {
                    return `btn-${this.component.style.backgroundColor}`
                }

                return ''
            },
            colorStyle() {
                if(this.isCustomColor) {
                    return `color: ${this.component.style.color};`
                }

                return ''
            },
            backgroundColorStyle() {
                if(this.isCustomBackgroundColor) {
                    return `background-color: ${this.component.style.backgroundColor};`
                    
                }

                return ''
            },
            borderRadiusStyle() {
                if(!this.component.style.borderRadius) {
                    return ''
                }

                return `border-radius: ${this.component.style.borderRadius}px;`
            },
            minWidthStyle() {
                if(!this.component.style.minWidth) {
                    return 'min-width: 120px;'
                }

                return `min-width: ${this.component.style.minWidth}px;`
            },
            isCustomColor() {
                return webase.utils.ui.isCustomColor( this.component )
            },
            isCustomBackgroundColor() {
                return webase.utils.ui.isCustomBackgroundColor( this.component )
            },
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted() {
            if (!this.component.redirectTo) {
                this.component.redirectTo = ''
            }
        },
        methods: {
            onButtonClick () {
                if(!this.executeClick) {
                    return
                }

                if(this.component.action === 'back') {
                    this.executeBack()
                }
                else if(this.component.action === 'save') {
                    this.$emit('onSaveEvent')
                }
                else if(this.component.action === 'sign up') {
                    this.$emit('onSignUpEvent')
                }
                else if(this.component.action === 'sign in') {
                    this.$emit('onSignInEvent')
                }
                else if(this.component.action === 'link') {
                    this.executeLink()
                }
            },
            executeBack () {
                this.$router.go(-1)
            },
            executeLink () {
                console.log(this.component)
                if(this.component.view && this.$router) {
                    this.$router.push({ name: 'view-renderer', params: {id: this.component.view}})
                }
                else if(this.component.resourceType === 'View' && this.component.resource && this.$router) {
                    this.$router.push({ name: 'view-renderer', params: {id: this.component.resource}})
                }
                else if((this.component.resourceType === 'Link' || this.component.resourceType === 'URL') && this.component.resource) {
                    window.open(this.component.resource);
                }
                else {
                    alert('A view is required for a link to function.  This can be set by clicking on this button in the ViewEditor.')
                    console.log(this.component)
                }
            }
        }
    }
</script>

<style>

</style>
